import type { CognitoFrontConfig } from "./idpSession";
import type { IdentityUser } from "./identity";

/**
 * El perfil del ID token de Cognito, con la forma que la app espera del `user` de Auth0.
 * El `sub` de Cognito es un UUID que no elegimos; el id de la persona (la PK de la base,
 * `auth0|...` o `cognito|...`) viaja en `cognito:username`. Todo lo que hoy usa `user.sub`
 * como id de la persona sigue funcionando.
 */
export function cognitoUserFromProfile(profile: Record<string, unknown>): IdentityUser {
  const username = profile["cognito:username"];
  return {
    ...profile,
    cognitoSub: profile.sub,
    sub: typeof username === "string" && username ? username : (profile.sub as string | undefined),
  };
}

/** El /logout del login hosteado: cierra su sesión (la del SSO) y vuelve a `returnTo`. */
export function cognitoLogoutUrl(config: CognitoFrontConfig, returnTo: string): string {
  const params = new URLSearchParams({ client_id: config.clientId, logout_uri: returnTo });
  return `${config.domain}/logout?${params.toString()}`;
}
